module.exports = __webpack_public_path__ + "media/images/display/blur-text-1-ae1b2c7129505de02bb97617d335ec33.png";